// Custom quantity selector for products with metafield - Override default quantity-input
(function() {
  'use strict';

  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    // Override the quantity button clicks using event delegation
    document.addEventListener('click', function(e) {
      const button = e.target.closest('.quantity__button');
      if (!button) return;

      const quantityInput = button.closest('quantity-input');
      if (!quantityInput) return;

      const input = quantityInput.querySelector('.quantity__input');
      if (!input) return;

      // Check if this product has custom quantity
      const customQuantity = input.getAttribute('data-custom-quantity');
      
      // If no custom quantity, let default behavior run
      if (!customQuantity || customQuantity === '' || customQuantity === '1') {
        return; // Exit and let Shopify's default handler work
      }

      // Only intercept if there's a custom quantity value > 1
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      const customQty = parseInt(customQuantity);
      const currentValue = parseInt(input.value) || 0;
      // "max" (via the max HTML attribute) carries the real stock cap too
      // (quantity_rule.max and/or available inventory, whichever is
      // smaller) — checking `!== null` rather than truthiness matters
      // because a max of 0 (out of stock) is falsy but still a real cap.
      const maxAttr = input.getAttribute('max');
      const maxValue = maxAttr !== null && maxAttr !== '' ? parseInt(maxAttr, 10) : null;
      // "step"/"min" carry Shopify's real quantity_rule.increment/min — the
      // only quantities the server will actually accept. The metafield step
      // (customQty) drives the UI's pack-size stepping but isn't guaranteed
      // to line up with quantity_rule, so we snap the result onto a valid
      // step from min; otherwise a mismatch sends a quantity the server
      // rejects with a 422.
      const stepAttr = input.getAttribute('step');
      const stepValue = stepAttr !== null && stepAttr !== '' ? parseInt(stepAttr, 10) || 1 : 1;
      const minAttr = input.getAttribute('min');
      const minValue = minAttr !== null && minAttr !== '' ? parseInt(minAttr, 10) || 0 : 0;
      const isPlus = button.getAttribute('name') === 'plus';

      let newValue;
      if (isPlus) {
        newValue = currentValue + customQty;
        // Respect max value if set
        if (maxValue !== null && newValue > maxValue) {
          newValue = maxValue;
        }
      } else {
        newValue = currentValue - customQty;
        // Allow going to 0 or below to remove item
        if (newValue < 0) {
          newValue = 0;
        }
      }

      if (newValue > 0 && stepValue > 1) {
        if (newValue < minValue) {
          newValue = minValue;
        } else {
          const stepsFromMin = Math.round((newValue - minValue) / stepValue);
          newValue = minValue + stepsFromMin * stepValue;
        }
        if (maxValue !== null && newValue > maxValue) {
          newValue = maxValue;
        }
      }

      // Already at the cap (e.g. a "+" that would exceed available stock) —
      // nothing to change, so skip firing an update.
      if (newValue === currentValue) return;

      // Update the input value
      input.value = newValue;

      // Get required data for cart update
      const line = input.dataset.index;
      const variantId = input.dataset.quantityVariantId;
      
      // Find the cart-items or cart-drawer-items element
      const cartItems = input.closest('cart-items') || input.closest('cart-drawer-items');
      
      if (cartItems && typeof cartItems.updateQuantity === 'function') {
        // Directly call the updateQuantity method
        cartItems.updateQuantity(line, newValue, button.getAttribute('name'), variantId);
      } else {
        // Fallback: trigger change event
        const changeEvent = new Event('change', { bubbles: true });
        input.dispatchEvent(changeEvent);
      }

    }, true); // Use capture phase to intercept before other handlers
  }

})();